import ResetPasswordModal from "../components/Modals/Password/ResetPassword/ResetPasswordModal";

export default ResetPasswordModal;